import { SHOW_MODAL, HIDE_MODAL } from '../actions/ActionTypes';
const initialState = {
  modal: null
};
export default ((state = initialState, action) => {
  switch (action.type) {
    case SHOW_MODAL:
      {
        const {
          modal
        } = action.payload;
        return Object.assign({}, state, {
          modal
        });
      }
    case HIDE_MODAL:
      return initialState;
    default:
      return state;
  }
});